import { useEffect } from 'react'

function usePreventBrowserBack() {
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', () => {
      window.history.pushState(null, document.title, window.location.href)
    })
  }, [])
}

export default usePreventBrowserBack
